module.exports = __webpack_public_path__ + "static/media/pre-sale-tvod.491f94c1.jpg";